import { useTranslation } from 'react-i18next';
import { MaintenanceTable } from '../../Layouts/DataTable';
import { EApiType, EDataMaintenanceType, EModuleType } from '../../../data/Constants';
import { getLanguageAssociation } from '../../../store/states/LanguageSlice';
import { useApiError } from '../../../hooks';

import type { IManagementProps } from '../../../../types';

export const LanguageAssociation = (props: IManagementProps) => {
  const { t } = useTranslation();
  const errorElement = useApiError(EApiType.LanguageAssociationKey);

  if (errorElement) return errorElement;

  return (
    <>
      <h3 className="mainHeader"> {t('header.languageAssociation')} </h3>
      <MaintenanceTable
        token={props.token}
        type={EDataMaintenanceType.LanguageAssociation}
        getDataList={getLanguageAssociation}
        moduleType={EModuleType.Datamaintainance}
      />
    </>
  );
};
